export default __webpack_public_path__ + "static/media/stacked-cards@3x.39e612d4.png";